import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { Box, Typography } from '@mui/material'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { NumberField } from 'src/Libs/inputs/formik'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import WeekDayList from './WeekDayList'
import ChargeStrategyClearButton from './ChargeStrategyClearButton'

interface Props {
  model: WallboxConfigurationModel
  displayCapacity?: boolean
  displayBidiMode?: boolean
  disabled?: boolean
}

/**
 * Display Charging Strategy settings for the new design (software version >= X_2024_04)
 */
const HysteresisFieldSetWithWeekDayCard: React.FC<Props> = ({ model, displayCapacity = false, displayBidiMode = false, disabled = false }) => {
  const { t } = useCustomTranslation()

  return (
    <Box>
      <Typography variant="h2" sx={{ pb: 2 }}>
        {t('systemSettings.wallbox.settings.hysteresis.title')}
      </Typography>

      <SettingsBox
        disabled={disabled}
        title={t('systemSettings.wallbox.settings.chargeStopHysteresis')}
        suffix={
          <NumberField
            name="chargeStopHysteresis"
            label={t('systemSettings.wallbox.settings.chargeStopHysteresis')}
            suffix="min"
            disabled={disabled}
          />
        }
      />

      <ChargeStrategyClearButton disabled={disabled} displayBidiMode={displayBidiMode} />

      <WeekDayList name="chargeStrategyConfiguration" disabled={disabled} />
    </Box>
  )
}

export default HysteresisFieldSetWithWeekDayCard
